module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-144x144-9599ef151aab850ba2392beb70ce2b10.png";